import {HotelImage} from './hotel-image.model';
import {HotelAddress} from './hotel-address.model';
import {mapToDateTimeFromString, useDefault, useFirst} from '../../../common/common';
import {HotelRegion} from './hotel-region.model';
import {HotelExtraFeature} from './hotel-extra-feature.model';
import {HotelExtraFeatureType} from './hotel-extra-feature-type.model';

const LASVN_HOTEL_MNEMONIC = 'LASVN';
const LASPL_HOTEL_MNEMONIC = 'LASPL';
const MFMPM_HOTEL_MNEMONIC = 'MFMPM';
const MFMVE_HOTEL_MNEMONIC = 'MFMVE';
const RATE_CHANGES_NEEDED_HOTEL_MNEMONICS = [LASVN_HOTEL_MNEMONIC, LASPL_HOTEL_MNEMONIC, MFMPM_HOTEL_MNEMONIC, MFMVE_HOTEL_MNEMONIC];
const LMS_HOTEL_MNEMONICS = [LASVN_HOTEL_MNEMONIC, LASPL_HOTEL_MNEMONIC];

export interface IFutureBrandInfo {
  rebrandingDate: string;
  chainCode: string;
  brandName: string;
  brandCode: string;
  hotelName: string;
}
export class Hotel {
  mnemonic: string;
  name: string;
  shortDescription: string;

  brandCode: string;
  brandName: string;
  futureBrandInfo?: IFutureBrandInfo;
  chainCode: string;
  seoCity: string;
  region: HotelRegion;
  address: HotelAddress;
  frontDeskNumber: string;
  latitude: number;
  longitude: number;
  vatIncluded: boolean;
  checkInTime: Date;
  checkOutTime: Date;
  images: HotelImage[] = [];
  extraFeatures: Map<string, any> = new Map();
  rating : number;

  static isRateChangesNeeded(mnemonic: string): boolean {
    return RATE_CHANGES_NEEDED_HOTEL_MNEMONICS.indexOf(useDefault(mnemonic, '').toUpperCase()) > -1;
  }
  static isLMS(mnemonic: string): boolean {
    return LMS_HOTEL_MNEMONICS.indexOf(useDefault(mnemonic, '').toUpperCase()) > -1;
  }
  constructor(mnemonic?: string, chainCode?: string) {
    this.mnemonic = mnemonic;
    this.chainCode = chainCode;
  }
  isInGreaterChina() {
    return HotelRegion.isGreaterChina(this.region);
  }
  getAspectImage (aspectWidth, aspectHeight): HotelImage {
    return this.images.find((image) => {
      return image.aspectWidth === aspectWidth
        && image.aspectHeight === aspectHeight
    }) || new HotelImage('');
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/hotel/hotel.model.ts